export const AudioExerciseRecipe = {
    $type$: 'Recipe',
    name: 'AudioExercise',
    rule: [
        {
            itemprop: 'name',
            itemtype: { type: 'string' }
        }
    ]
};
const AudioExerciseRecipes = [AudioExerciseRecipe];
export default AudioExerciseRecipes;
//# sourceMappingURL=AudioExerciseRecipes.js.map